<template>
  <v-snackbar :color="color" :timeout="-1" :value="display" :multi-line="true" text outlined tile app top>
    <div class="tw-flex tw-items-center">
      <v-icon v-if="color === 'error'" class="tw-mr-4" color="red">
        fa-exclamation-triangle
      </v-icon>
      <v-icon v-else-if="color === 'success'" class="tw-mr-4" color="green">
        fa-check
      </v-icon>

      <div>
        <div v-if="typeof lines === 'string'" v-html="lines"></div>

        <ul v-else-if="lines instanceof Array">
          <li v-for="(line, key) in lines" :key="key" class="tw-list-disc">
            {{ line }}
          </li>
        </ul>

        <template v-else>
          <div v-for="(line, key) in lines" :key="key">
            <span class="tw-font-semibold">
              {{ key }}
            </span>
            <ul>
              <li v-for="(info, key) in line" :key="key" class="tw-list-disc">
                {{ info }}
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>

    <template v-slot:action>
      <v-icon :title="$t('common.close')" class="tw-m-4" :color="color" small @click="close">
        fa-times
      </v-icon>
    </template>
  </v-snackbar>
</template>

<script>
import { Types } from "../../../store/modules/snackbar"

export default {
  name: "Snackbar",
  computed: {
    color() {
      return this.$store.state.snackbar.color
    },
    display() {
      return this.$store.state.snackbar.display
    },
    lines() {
      return this.$store.state.snackbar.lines
    },
  },
  methods: {
    close() {
      this.$store.dispatch(Types.actions.HIDE)
    },
  },
}
</script>
